export default __webpack_public_path__ + "media/images/theme/bg_dark-da946e7803c03f2ef094f28ea526f7af.png";